/* SMT-V144-GLOBAL-HEADER */
(function () {
  'use strict';

  var root = document.documentElement;
  var directionsUrl = 'https://google.com/maps/place/ULUDA%C4%9E+OTO+KILIF+-+SINCE+1984/@37.7608798,29.0809008,15z/data=!4m6!3m5!1s0x14c73fb9f0254b27:0x9ecb44a8d23a676d!8m2!3d37.7852949!4d29.0787579!16s%2Fg%2F11bx9mzn_y';

  function tickerGroup() {
    return [
      '<div class="smt-v144-global-header__ticker-group">',
      '<span class="smt-v144-global-header__ticker-item smt-v144-global-header__ticker-item--star"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 3.8 14.1 8.3 19 8.8 15.3 12.1 16.4 17 12 14.5 7.6 17 8.7 12.1 5 8.8 9.9 8.3Z"></path></svg><span>1984\u2019ten beri</span></span>',
      '<span class="smt-v144-global-header__ticker-item"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M5 18.5 9.2 9M15 18.5l4-9M3.5 19h17"></path></svg><span>Denizli\u2019de oto aksesuar uzmanl\u0131\u011f\u0131</span></span>',
      '<span class="smt-v144-global-header__ticker-item"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M8 5.5h5.5l2 8.5H9.5L8 5.5ZM9.5 14h8.7a2.3 2.3 0 0 1 0 4.6H11"></path></svg><span>Türkiye geneli güvenli gönderim</span></span>',
      '<span class="smt-v144-global-header__ticker-item"><svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.2"></circle><circle cx="12" cy="12" r="2.1"></circle><path d="M4.4 10.4h15.2M12 14.1v5.7M8.7 11.2 12 14.1l3.3-2.9"></path></svg><span>Arac\u0131n\u0131za uygun \u00fcr\u00fcn se\u00e7imi</span></span>',
      '</div>'
    ].join('');
  }

  function buildHeader() {
    var logoUrl = window.SMT_V144_HEADER_LOGO || '';
    var config = window.SMT_V157_HEADER_CONFIG || {};
    var rootUrl = config.rootUrl || '/';
    var accountUrl = config.accountUrl || '/account/login';
    var accountLabel = config.accountLabel || 'Kullan\u0131c\u0131 giri\u015fi';
    var cartUrl = config.cartUrl || '/cart';
    var cartCount = Number(config.cartCount) || 0;
    var cartBadge = cartCount > 0
      ? '<span class="smt-v157-cart-count" aria-hidden="true">' + (cartCount > 99 ? '99+' : cartCount) + '</span>'
      : '';
    var shell = document.createElement('div');
    shell.id = 'smt-v144-global-header';
    shell.className = 'smt-v144-global-header';
    shell.innerHTML = [
      '<div class="smt-v144-global-header__ticker" aria-label="1984\u2019ten beri Denizli\u2019de oto aksesuar uzmanl\u0131\u011f\u0131">',
      '<div class="smt-v144-global-header__track">', tickerGroup(), tickerGroup(), '</div></div>',
      '<header class="smt-v144-global-header__main">',
      '<div class="smt-v144-global-header__inner">',
      '<button class="smt-v144-global-header__menu-button" type="button" aria-label="Men\u00fcy\u00fc a\u00e7" aria-controls="smt-v144-mobile-menu" aria-expanded="false"><span></span><span></span><span></span></button>',
      '<a class="smt-v144-global-header__brand" href="', rootUrl, '" aria-label="SMT Oto Tekstil ana sayfa"><img src="', logoUrl, '" width="420" height="210" alt="SMT Oto Tekstil ve Aksesuar"></a>',
      '<nav class="smt-v144-global-header__nav" aria-label="Ana men\u00fc">',
      '<a href="/collections/universal-oto-koltuk-kilifi">Koltuk K\u0131l\u0131f\u0131</a>',
      '<a href="/collections/oto-paspas">Paspas</a>',
      '<a href="/collections/oto-koltuk-minderi">Minder</a>',
      '<a href="/collections/oto-aksesuar">Aksesuar</a>',
      '</nav>',
      '<div class="smt-v144-global-header__actions">',
      '<a class="smt-v144-global-header__search" href="/search" aria-label="Ara" title="Ara"><svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="10.8" cy="10.8" r="6.7"></circle><path d="m16 16 4.2 4.2"></path></svg></a>',
      '<a class="smt-v157-header-icon" href="', accountUrl, '" aria-label="', accountLabel, '" title="', accountLabel, '"><svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.5"></circle><path d="M5.5 20c.7-4 3-6 6.5-6s5.8 2 6.5 6"></path></svg></a>',
      '<a class="smt-v157-header-icon smt-v157-cart-link" href="', cartUrl, '" aria-label="Sepet, ', cartCount, ' \u00fcr\u00fcn" title="Sepet"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M6.5 8.5h11l-.8 11h-9.4l-.8-11Z"></path><path d="M9 9V7a3 3 0 0 1 6 0v2"></path></svg>', cartBadge, '</a>',
      '<a class="smt-v144-global-header__directions" href="', directionsUrl, '" target="_blank" rel="noopener" aria-label="Google Maps ile yol tarifi al"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M3.8 10.7 20.5 3.5 13.3 20.2 10.8 13.2 3.8 10.7Z"></path><path d="m10.8 13.2 4.8-4.8"></path></svg><span>Yol Tarifi</span></a>',
      '</div>',
      '</div>',
      '<nav class="smt-v144-global-header__mobile-menu" id="smt-v144-mobile-menu" aria-label="Mobil men\u00fc" hidden>',
      '<a href="/collections/universal-oto-koltuk-kilifi">Koltuk K\u0131l\u0131f\u0131</a>',
      '<a href="/collections/oto-paspas">Paspas</a>',
      '<a href="/collections/oto-koltuk-minderi">Minder</a>',
      '<a href="/collections/oto-aksesuar">Aksesuar</a>',
      '<a href="/search">Ara</a>',
      '</nav></header>'
    ].join('');

    var nativeHeader = document.querySelector('.shopify-section-group-header-group');
    if (nativeHeader && nativeHeader.parentNode) {
      nativeHeader.parentNode.insertBefore(shell, nativeHeader);
      if (!(window.Shopify && Shopify.designMode)) nativeHeader.remove();
    } else {
      document.body.insertBefore(shell, document.body.firstChild);
    }

    var spacer = document.createElement('div');
    spacer.id = 'smt-v144-global-header-spacer';
    spacer.className = 'smt-v144-global-header-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    shell.parentNode.insertBefore(spacer, shell.nextSibling);
    root.classList.add('smt-v144-global-header-active');
    return { shell: shell, spacer: spacer };
  }

  function bindMobileMenu(shell) {
    var button = shell.querySelector('.smt-v144-global-header__menu-button');
    var menu = shell.querySelector('.smt-v144-global-header__mobile-menu');
    if (!button || !menu) return;

    function closeMenu() {
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-label', 'Men\u00fcy\u00fc a\u00e7');
      menu.hidden = true;
    }

    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMenu();
      } else {
        root.classList.remove('smt-v144-header-hidden');
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', 'Men\u00fcy\u00fc kapat');
        menu.hidden = false;
      }
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  function bindAutoHide(shell, spacer) {
    var lastY = Math.max(0, window.scrollY || 0);
    var ticking = false;
    var height = 0;

    function measure() {
      height = Math.ceil(shell.getBoundingClientRect().height);
      root.style.setProperty('--smt-v144-header-height', height + 'px');
      if (spacer) spacer.style.height = height + 'px';
    }

    function update() {
      var currentY = Math.max(0, window.scrollY || 0);
      var delta = currentY - lastY;
      var menuOpen = !!shell.querySelector('[aria-expanded="true"]');

      if (currentY <= 12 || menuOpen) {
        root.classList.remove('smt-v144-header-hidden');
      } else if (delta > 7 && currentY > height + 24) {
        root.classList.add('smt-v144-header-hidden');
      } else if (delta < -7) {
        root.classList.remove('smt-v144-header-hidden');
      }

      if (Math.abs(delta) > 7) lastY = currentY;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    measure();
    window.requestAnimationFrame(measure);
    window.addEventListener('load', measure, { once: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('orientationchange', measure, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('mousemove', function (event) {
      if (event.clientY < 14) root.classList.remove('smt-v144-header-hidden');
    }, { passive: true });
    shell.addEventListener('focusin', function () {
      root.classList.remove('smt-v144-header-hidden');
    });

    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(shell);
  }

  function initialize() {
    var existingShell = document.getElementById('smt-fixed-header-shell');
    var shell;
    var spacer;

    if (existingShell) {
      shell = existingShell;
      spacer = document.getElementById('smt-fixed-header-spacer');
      root.classList.add('smt-v144-global-header-active');
    } else {
      var built = buildHeader();
      shell = built.shell;
      spacer = built.spacer;
      bindMobileMenu(shell);
    }

    bindAutoHide(shell, spacer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();

/* SMT-V149-MOBILE-CATEGORY-MENU-FIX-START */
(function () {
  'use strict';

  var root = document.documentElement;

  function ensureMenu(shell) {
    var menu = shell.querySelector('.smt-v144-global-header__mobile-menu');
    if (menu) return menu;

    menu = document.createElement('nav');
    menu.className = 'smt-v144-global-header__mobile-menu';
    menu.id = 'smt-v144-mobile-menu';
    menu.setAttribute('aria-label', 'Mobil men\u00FC');
    menu.hidden = true;
    menu.innerHTML = [
      '<a href="/collections/universal-oto-koltuk-kilifi">Koltuk K\u0131l\u0131f\u0131</a>',
      '<a href="/collections/oto-paspas">Paspas</a>',
      '<a href="/collections/oto-koltuk-minderi">Minder</a>',
      '<a href="/collections/oto-aksesuar">Aksesuar</a>'
    ].join('');
    (shell.querySelector('.smt-v144-global-header__main') || shell).appendChild(menu);
    return menu;
  }

  function bind(shell) {
    if (!shell || shell.dataset.smtV149MenuBound === 'true') return true;
    var button = shell.querySelector('.smt-v144-global-header__menu-button, [aria-controls="smt-v144-mobile-menu"]');
    if (!button) return false;
    var menu = ensureMenu(shell);
    shell.dataset.smtV149MenuBound = 'true';

    function setOpen(open) {
      root.classList.remove('smt-v144-header-hidden');
      root.classList.toggle('smt-v149-mobile-menu-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      button.setAttribute('aria-label', open ? 'Men\u00FCy\u00FC kapat' : 'Men\u00FCy\u00FC a\u00E7');
      menu.hidden = !open;
    }

    setOpen(false);
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(button.getAttribute('aria-expanded') !== 'true');
    }, true);

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setOpen(false);
    });
    document.addEventListener('click', function (event) {
      if (button.getAttribute('aria-expanded') === 'true' && !shell.contains(event.target)) setOpen(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) setOpen(false);
    }, { passive: true });
    return true;
  }

  function initialize() {
    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var shell = document.getElementById('smt-v144-global-header') || document.getElementById('smt-fixed-header-shell');
      if (bind(shell) || attempts >= 80) window.clearInterval(timer);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
/* SMT-V149-MOBILE-CATEGORY-MENU-FIX-END */

/* SMT seat cover category navigation */
(function () {
  'use strict';
  function initialize() {
    var shell = document.getElementById('smt-v144-global-header') || document.getElementById('smt-fixed-header-shell');
    if (!shell) return;
    var style = document.createElement('style');
    style.textContent = '.smt-seat-menu{position:relative;color:inherit;font:inherit}.smt-seat-menu summary{cursor:pointer;list-style:none;font-weight:700;white-space:nowrap}.smt-seat-menu summary::-webkit-details-marker{display:none}.smt-seat-menu summary:after{content:" ▾";font-size:.75em}.smt-seat-menu-panel{position:absolute;top:100%;left:0;min-width:250px;padding:10px;background:#111;border:1px solid #65522d;border-radius:5px;box-shadow:0 8px 24px #0005;z-index:100}.smt-seat-menu-panel a{display:block!important;padding:12px!important;margin:0!important;color:#f5ede0!important;white-space:nowrap;font-size:14px!important;line-height:1.5!important}.smt-seat-menu-panel a:hover,.smt-seat-menu-panel a:focus-visible{background:#30291d}.smt-seat-menu:focus-within{z-index:101}@media(max-width:900px){.smt-seat-menu{padding:14px 18px}.smt-seat-menu-panel{position:static;min-width:0;margin-top:10px;box-shadow:none}.smt-seat-menu-panel a{white-space:normal}}';
    document.head.appendChild(style);
    shell.querySelectorAll('nav a[href="/collections/universal-oto-koltuk-kilifi"]').forEach(function (link) {
      if (link.closest('.smt-seat-menu')) return;
      var details = document.createElement('details');
      details.className = 'smt-seat-menu';
      details.innerHTML = '<summary>Koltuk Kılıfı</summary><div class="smt-seat-menu-panel"><a href="/collections/koltuk-kilifi">Tüm Koltuk Kılıfları</a><a href="/collections/araca-ozel-oto-koltuk-kilifi">Araca Özel Koltuk Kılıfı</a><a href="/collections/universal-oto-koltuk-kilifi">Üniversal Koltuk Kılıfı</a></div>';
      link.replaceWith(details);
    });
    document.addEventListener('click', function (e) { shell.querySelectorAll('.smt-seat-menu[open]').forEach(function (d) { if (!d.contains(e.target)) d.open=false; }); });
    document.addEventListener('keydown', function (e) { if(e.key==='Escape') shell.querySelectorAll('.smt-seat-menu[open]').forEach(function(d){d.open=false;}); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true}); else initialize();
})();
